var _rect, _rect2, _rect3, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowcaseMainTabFiledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 7,
    height: 7,
    rx: 1,
    fill: "url(#paint0_linear_78_9153)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 7,
    height: 7,
    rx: 1,
    fill: "url(#paint1_linear_78_9153)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12.0002,
    width: 7,
    height: 7,
    rx: 1,
    fill: "url(#paint2_linear_78_9153)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.0002,
    width: 7,
    height: 7,
    rx: 1,
    fill: "url(#paint3_linear_78_9153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_9153",
    x1: 4.545,
    y1: 7.5,
    x2: 11.5601,
    y2: 11.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_9153",
    x1: 12.545,
    y1: 7.5,
    x2: 19.5601,
    y2: 11.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_9153",
    x1: 4.545,
    y1: 15.5002,
    x2: 11.5601,
    y2: 19.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_78_9153",
    x1: 12.545,
    y1: 15.5002,
    x2: 19.5601,
    y2: 19.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseMainTabFiledIcon);
export default __webpack_public_path__ + "static/media/showcase-main-tab-filed-icon.d1459d384c40cf7d84ad7fc6f5d47c17.svg";
export { ForwardRef as ReactComponent };